import React, { createContext, useContext, useEffect, useState } from 'react';

interface LanguageContextValue {
  locale: string;
  setLocale: (lang: string) => void;
}

const LanguageContext = createContext<LanguageContextValue>({
  locale: 'en',
  setLocale: () => {}
});

export const useLanguage = () => useContext(LanguageContext);

const LANGUAGE_STORAGE_KEY = 'preferred_language';

interface LanguageProviderProps {
  children: React.ReactNode;
  defaultLocale?: string;
}

export const LanguageProvider: React.FC<LanguageProviderProps> = ({
  children,
  defaultLocale = 'en'
}) => {
  const [locale, setLocale] = useState<string>(() => {
    return localStorage.getItem(LANGUAGE_STORAGE_KEY) || defaultLocale;
  });

  useEffect(() => {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, locale);
  }, [locale]);

  return (
    <LanguageContext.Provider value={{ locale, setLocale }}>
      {children}
    </LanguageContext.Provider>
  );
};
